<template>
  <div>
    <el-form
    ref="form"
      :model="form"
      :rules="rules"
      :label-width="'200px'"
      :inline="false"
      label-position="top"
      :span="12"
    >
      <el-form-item :label="$t('routes.name')" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item prop="points">
        <slot name="label">
          {{$t('home.tree')}}
          <el-tooltip :content="$t('common.selectPointsFromLeftTree')" placement="top">
            <em class="el-icon-info"></em>
          </el-tooltip>
        </slot>
        <br />

        <el-tree
          ref="tree"
          :data="tree"
          default-expand-all
          node-key="_id"
          :props="options"
          :filter-node-method="filterNode"
          highlight-current
          :expand-on-click-node="false"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <span>
              <span v-if="node.data.nodeType =='point'">
                <em class="fas fa-crosshairs"></em>
                {{node.data.name}}
              </span>
              <span v-if="node.data.nodeType =='group'">{{node.data.name}}</span>
            </span>
          </span>
        </el-tree>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save()">{{$t('common.save')}}</el-button>
        <el-button @click="cancel()">{{$t('common.cancel')}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";
export default {
  name: "EditRoute",
  events: ["updated", "cancelled"],
  props: ["route"],
  data() {
    return {
      options: {
        label: "name",
        children: "children",
        checkbox: false
      },
      form: {
        name: "",
        points: []
      },
      rules: {
        name: [
          { required: true, message: this.$t('point.inputName'), trigger: "blur" }
        ],
        points: [
          {
            type: "array",
            required: true,
            message: this.$t('common.leastOnePoint'),
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.form = {
      name: this.route.name,
      points: this.route.points
    };
    this.$bus.emit(
      "selectNodes",
      this.route.tree.filter(x => x.nodeType == "point").map(x => x._id)
    );
  },
  mounted() {
    this.$refs.tree.filter();
  },
  watch: {
    checkedNodes() {
      this.$refs.tree.filter();
      this.form.points = this.activePoints;
    }
  },
  computed: {
    ...mapState("tree", ["tree", "checkedNodes", "activePoints"])
  },
  methods: {
    ...mapActions("route", ["updateRoute"]),
    filterNode(value, data) {
      return this.checkedNodes.map(x => x._id).includes(data._id);
    },
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.updateRoute({
            _id: this.route._id,
            name: this.form.name,
            points: this.activePoints
          }).then(() => {
            this.$emit("updated");
          });
          this.$bus.emit("selectNodes", []);
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.$emit("cancelled");
      this.$bus.emit("selectNodes", []);
    }
  }
};
</script>

<style>
</style>